import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../../store';
import axios from 'axios';
import { updateSelectedBusData, updateRatingReviewData, updateBusDetailLoading } from './actions';
import {
  prepareSeatLayoutAPIRequest,
  prepapreRatingReviewAPIRequest,
  prepareRedDealAPIRequest,
  prepareCancellationPolicyURL,
  prepareBusDeatilRequest,
  prepareRedDealAPIRequestNew
} from '../Api';
import { IBUS_SEAT_LAYOUT_DATA } from './../helpers/validation';
import querystring from 'query-string';
import dateFormat from 'dateformat';
import { seatTabConfig } from './../helpers/config';
import megatron from '@stencil/megatron';
import getDateObj from './../../../utils/GetDateObj';
import { pushDataToNewrelic } from './../../Common/Utils'
//TODO:- handle the failure cases . ... add a dispatch action in case of error or failure so that it should be handled by state management .
//TODO:- add a check ro not fetch data again if bid data already present
export const fetchSeatLayoutData = (params): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const { busInfo, selectedBP, selectedDP, cat_type, fetch } = params;
    const state = getState();
    const { selectedSeatLayoutData } = state.seatLayout;
    // if (fetch === true) {
    //     console.log('in fetch if')
    // } else if (selectedSeatLayoutData && busInfo && busInfo.bid && selectedSeatLayoutData.hasOwnProperty(busInfo.bid) && !selectedSeatLayoutData[busInfo.bid].error && selectedSeatLayoutData[busInfo.bid]['data'] && Object.keys(selectedSeatLayoutData[busInfo.bid]['data']).length) {
    //   return;
    // }
    dispatch(updateSelectedBusData({ bid: busInfo.bid, data: {}, isLoading: true, error: false }));
    /**
     *
     * {"searchtype":"onwardflights","routeid":"redbusnew@1000000134290184109",
     * "destination":"Hyderabad","origin":"Bengaluru","journey_date":"2020-05-22",
     * "src_vid":"6771549831164675055","dest_vid":"2162254155836171767","src_id":"3","dest_id":"6",
     * "bpid":"","dpid":"",
     * "bid":"Bengaluru/Hyderabad/2115/SRSTravels/NONACSleeper2+1-redbusnew@1000000134290184109-22-2020/05/22",
     * "op":"22","all_data_required":true,"flavour":"mweb","vertical":"bus"}
     */

    const url = prepareSeatLayoutAPIRequest();
    const {
      searchtype,
      fh: routeid,
      origin,
      destination,
      journey_date,
      src_vid,
      dest_vid,
      src_id,
      dest_id,
      bid,
      op,
    } = busInfo;
    let body = {
      searchtype, //backend refactor
      routeid, //fh
      origin, //common
      destination, //common
      journey_date, //common
      src_vid, //common
      dest_vid, //common
      src_id, //src_id
      dest_id, //dest_id
      bpid: selectedBP && selectedBP.id ? selectedBP.id : '',
      dpid: selectedDP && selectedDP.id ? selectedDP.id : '',
      bid,
      op, //op
      all_data_required: true, // true if you want bp dp in seatlayout as well.
      flavour: 'dweb',
      vertical: 'bus',
      cat_type: cat_type ? JSON.stringify(cat_type) : '',
    };

    let queryData = encodeURIComponent(JSON.stringify(body));
    queryData = 'queryData=' + queryData;
    //TODO:- change the axios call


    try {
      const response = await megatron({
        name: 'Bus Seat Layout',
        type: 'POST',
        url,
        requestData: queryData,
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
      const { data, status } = response;
      if (status) {
        if (Object.keys(data).length) {
          const seatInfo = getSeatLayoutStoreData(data, busInfo.bid);
          dispatch(updateSelectedBusData({ bid: busInfo.bid, data: seatInfo.data, isLoading: false, error: false }));

          pushDataToNewrelic(`seatLayoutData=success&bps=${seatInfo.data.bps.length}&dps=${seatInfo.data.dps.length}&bid=${busInfo.bid}`);

        } else {
          dispatch(updateSelectedBusData({ bid: busInfo.bid, data: {}, isLoading: false, error: false }));


        }

      } else {
        dispatch(updateSelectedBusData({ bid: busInfo.bid, data: {}, isLoading: false, error: true }));


      }
    } catch (err) {
      dispatch(updateSelectedBusData({ bid: busInfo.bid, data: {}, isLoading: false, error: true }));

    }

  };
};

function getSeatLayoutStoreData(data: IBUS_SEAT_LAYOUT_DATA, bid: string) {
  const { m_allowed, m_rows, m_cols, impulse, seats, f_map, bps, dps, route_id, f_b_map } = data;

  const busInfo = {
    isFetching: true,
    selectedTab: Object.keys(seatTabConfig)[0],
    selectedSeats: {},
    selectedCategory: '',
    selectedBP: {},
    selectedDP: {},
    selectedPrice: [-1], //default to -1 which means 'all' option to be selected .
    availableSeatPrice: [-1], //show the seat price .. -1 for all tag in price list.
    data: { availableSeatPrice: [-1], seats: { upper_deck: {}, lower_deck: {} } },
    fareInfo: { priceAfterDiscount: 0, priceWithoutDiscount: 0, discount: 0 },
    fareBreakupMap: f_b_map
  };
  busInfo.data['maxSeatAllowed'] = m_allowed;
  busInfo.data['maxRows'] = m_rows;
  busInfo.data['maxcol'] = m_cols;
  busInfo.data['impulse'] = impulse;
  busInfo.data['fare_info'] = f_map;
  busInfo.data['fareBreakupMap'] = f_b_map;
  busInfo.data['bps'] = (function () {
    return bps.map(bp => {
      bp.viewTime = dateFormat(getDateObj(bp.time.substring(0, bp.time.length - 1)), 'HH:MM');
      return bp;
    });
  })();
  busInfo.data['dps'] = (function () {
    return dps.map(dp => {
      dp.viewTime = dateFormat(getDateObj(dp.time.substring(0, dp.time.length - 1)), 'HH:MM');
      return dp;
    });
  })();
  busInfo.data['route_id'] = route_id;
  let trackData = {
    isSleeper: false,
    count: 0,
    minCount: 15
  };
  for (const deck in seats) {
    busInfo.selectedSeats[deck] = [];
    if (seats.hasOwnProperty(deck)) {

      const deckInfo = seats[deck];
      if (deckInfo && deckInfo.length > trackData.minCount) {
        trackData.count = +deckInfo.length;
      }
      for (let i in deckInfo) {
        const seatData = deckInfo[i];
        const seatStatus = seatData.sst.toLowerCase();
        const isSeater = seatData.st.toLowerCase().indexOf('seater') !== -1;
        if (!isSeater) {
          trackData.isSleeper = true;
        }
        if (busInfo.data.availableSeatPrice.indexOf(seatData.bf) === -1) {
          busInfo.data.availableSeatPrice.push(seatData.bf);
        }
        busInfo.data['seats'][deck][seatData.sn] = {
          ...seatData,
          lseat: seatStatus.indexOf('ladies') !== -1,
          currentType: '',
          nextType: '',
          isSleeper: !isSeater,
          isSeater: isSeater,
          deck: deck,
          isAvailable: seatStatus.indexOf('available') !== -1,
          //for Vertical sleeper top position must be +10(30+10)and left position will be -10
          top: (function () {
            return isSeater ? seatData.rrn * 22 + 'px' : seatData.rrn * 30 + 'px';
          })(),
          left: (function () {
            return isSeater ? seatData.cn * 24 + 'px' : seatData.cn * 24 + 'px';
          })(),
          orientation: (function () {
            return seatData.h === 1 && seatData.w === 2 ? 'vertical' : 'horizontal';
          })(),
          route_id: route_id,
          bid: bid,
        };
      }
    }
  }
  if (trackData.isSleeper && trackData.count > trackData.minCount) {
    pushDataToNewrelic(`seatLayoutData=${trackData.isSleeper}&value=${bid}&count=${trackData.count}`);

  }
  return busInfo;
}
//TODO:- handle the failure cases . ... add a dispatcha ction in case of error or failure so that it should be handled by state management .
//TODO:- add a check ro not fetch data again if bid data already present
export const fetchRatingReviewData = ({ bid, routeId }): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();
    if (state.seatLayout.ratingReviewData && state.seatLayout.ratingReviewData[bid] && state.seatLayout.ratingReviewData[bid].data) {
      dispatch(updateRatingReviewData({ bid, data: state.seatLayout.ratingReviewData[bid].data, isLoading: false }));
      return;
    }

    dispatch(updateRatingReviewData({ isLoading: true, bid }));
    const url = prepapreRatingReviewAPIRequest(routeId);
    let data;
    try {
      data = await megatron({
        name: 'Bus rating Review API',
        type: 'GET',
        url,
      });
      if (data && data.success) {
        const ratingReviewData = formatReviewData(data.data);
        dispatch(updateRatingReviewData({ bid, data: ratingReviewData, isLoading: false }));

      } else {
        dispatch(updateRatingReviewData({ bid, error: true, isLoading: false }));

      }
    } catch (err) {
      dispatch(updateRatingReviewData({ bid, error: true, isLoading: false }));
      console.error(err);
    }

  };
};
const config = {
  staffBehaviour: -1,
  busQuality: -1,
  punctuality: -1,
};
function formatReviewData(reviews) {
  let { all = [], totalRating } = reviews;
  let pos = [];
  let cri = [];
  const liked = {};
  const disliked = {};
  const totalReviewsCount = all.length;
  for (let i in all) {
    if (all[i].isNegative) {
      cri.push(all[i]);

    }
    if (all[i].isPositive) {
      pos.push(all[i]);

    }

    if (all[i].tagData) {
      if (all[i].tagData.Positive && all[i].tagData.Positive.length) {
        for (const p in all[i].tagData.Positive) {
          if (all[i].liked) {
            all[i].liked += `,${all[i].tagData.Positive[p].ReviewTagMsg}`;

          } else {
            all[i].liked = all[i].tagData.Positive[p].ReviewTagMsg;
          }
        }
      }

    }
  }

  return {

    positive: pos,
    all,
    critical: cri,
    overallRating: totalRating,
    liked,
    disliked,
    totalReviewsCount,

  };
}
export async function fetchRedDealData(journeyDate, routeId, selectedSeats) {
  let data;
  try {
    const query = `${journeyDate}/${routeId}/${selectedSeats.join(',')}`;
    const url = prepareRedDealAPIRequest(query);
    data = await megatron({
      name: 'Bus Search API',
      type: 'GET',
      url,
    });
  } catch (e) {
    console.log('Red Deal API Failed', e.error);
    console.trace(e);
  }

  return data;
}

export const fetchBusDetails = (bus): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();

    const src_id = state?.common?.src_vid;
    const dest_id = state?.common?.dest_vid;
    const src = state?.common?.src_name;
    const dest = state?.common?.dest_name;
    const doj = state?.common?.doj;
    const routeId = bus?.fh;
    const bid = bus?.bid;

    if (state.seatLayout.busDetails && state.seatLayout.busDetails[bid] && state.seatLayout.busDetails[bid].data) {
      dispatch(updateBusDetailLoading({ bid: bid, isLoading: false, data: state.seatLayout.busDetails[bid].data }));
      return;
    }
    dispatch(updateBusDetailLoading({ bid: bid, isLoading: true }));
    let data;
    try {
      const url = prepareBusDeatilRequest();
      data = await megatron({
        name: 'Bus Detail API',
        type: 'POST',
        url,
        requestData: querystring.stringify({src:src,dest:dest,src_id:src_id,dest_id:dest_id,doj:doj,route_id:routeId,all_data_req:'True'}),
        headers: {"content-type":"application/x-www-form-urlencoded;charset=UTF-8"}
      });
      if (data.error) {
        throw 'err';
      }
      dispatch(updateBusDetailLoading({ bid: bid, isLoading: false, data: data }));
    } catch (e) {
      dispatch(updateBusDetailLoading({ bid: bid, isLoading: false, error: true }));

      console.log('BUS Detail API', e.error);
      console.trace(e);
    }
  }
}

export async function fetchRedDealDataNew(journeyDate, routeId, selectedSeats, busData) {
  let seatStr = '';
  selectedSeats && selectedSeats.map((seat)=>{
    seatStr=seatStr+`${seat}`+','
    })
    seatStr=seatStr.slice(0,-1);
  const src_vid = busData?.src_vid;
  const dest_vid = busData?.dest_vid;
  const origin = busData?.origin;
  const destination = busData?.destination;
  const journey_date = busData?.journey_date;
  const bid = busData?.bid;
  const op = busData?.op;
  let data;
  try {
    const url = prepareRedDealAPIRequestNew();
    const qryData = {origin:origin,destination:destination,src_vid:src_vid,dest_vid:dest_vid,journey_date:journey_date,routeid:routeId,bid:bid,op:op}
    data = await megatron({
      name: 'Bus Search API',
      type: 'POST',
      url,
      credentials: 'include',
      requestData: querystring.stringify({queryData:JSON.stringify(qryData), seats:seatStr,reddeals:true,bestpromo:false}),
      headers: {"content-type":"application/x-www-form-urlencoded;charset=UTF-8"}
    });
  } catch (e) {
    console.log('Red Deal API Failed', e.error);
    console.trace(e);
  }
  const {deals, seats} = data;
  if(deals.length>0){
    deals[0].disc_val = parseInt(deals[0].disc_val)*-1;
    const dwebStyleData = {...deals[0], seats}
    return dwebStyleData;
  }
}

export const fetchCancellationPolicy = (bid: string, src_vid: string, dest_vid: string, tripKey:string = ''): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    let data;
    try {
      const url = prepareCancellationPolicyURL(bid, src_vid, dest_vid, tripKey);
      data = await axios.get(url).then((response) => {
        return Promise.resolve(response);
      }).catch(err => {
        console.log(err);
        return onCancellationFailure();
      })
      return data;

    } catch (e) {
      console.log('Bus Cancellation API Failed', e);
      console.trace(e);
      return onCancellationFailure();
    }
  };
};
function onCancellationFailure() {
  return Promise.resolve(
    '<p class="width100 fl marginT10 pad10">Sorry !! Unable to load cancellation policy.</p>'
  );
}
